import React from 'react';

const ProgrammeOutcomes = () => {
  return (
    <div>
      ProgrammeOutcomes
      ProgrammeOutcomes
    </div>
  );
}

export default ProgrammeOutcomes;
